<template>
  <div>
    <stripe-elements
      ref="stripeElements"
      :billing-details="billingDetails"
      mode="payment"
      :currency="currency"
      :amount="amount"
      :public-key="publicKey"
      :wallets="wallets"
      v-on="$listeners"
    ></stripe-elements>
  </div>
</template>

<script>
import StripeElements from './StripeElements.vue';

export default {
  components: { StripeElements },
  props: {
    publicKey: {
      type: String,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
    customerEmail: {
      type: String,
      default: null,
    },
    customerCountry: {
      type: String,
      default: null,
    },
    wallets: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    billingDetails() {
      return {
        address: {
          country: this.customerCountry,
        },
      };
    },
  },
  methods: {
    async createPaymentMethod() {
      const { paymentMethod, error } = await this.$refs.stripeElements.createPaymentMethod({});

      if (paymentMethod && !error) {
        this.$emit('stripe:payment-method-created', paymentMethod);
        return { paymentMethodId: paymentMethod.id };
      } else {
        this.$emit('stripe:failed', error);
        return null;
      }
    },
  },
};
</script>
